(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      }
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      )
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }
  }

  customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wing-quiz"]) return;
  try {
    
(function () {
  if (window.__wingQuizInstalled) return;
  window.__wingQuizInstalled = true;
  var cleanup = null;
  function mount() {
    if (cleanup) cleanup();
    var root = document.querySelector('[data-wing-quiz-root]');
    if (!root) return;
    var dialog = root.querySelector('dialog');
    var config = JSON.parse(root.querySelector('[data-wq-config]').textContent);
    var body = root.querySelector('[data-wq-body]');
    var title = root.querySelector('#WingQuizTitle');
    var intro = root.querySelector('[data-wq-intro]');
    var next = root.querySelector('[data-wq-next]');
    var back = root.querySelector('[data-wq-back]');
    var scroll = root.querySelector('[data-wq-scroll]');
    var progress = root.querySelector('[data-wq-progress]');
    var label = root.querySelector('[data-wq-progress-label]');
    var controller = new AbortController();
    var signal = controller.signal;
    var returnFocus = null;
    var priorOverflow = null;
    var storageKey = 'theguideliner-wing-quiz-v1';
    var answers = { shape: '', look: '', drama: '', color: '' };
    var step = 0;
    var questionKeys = ['shape', 'look', 'drama', 'color'];
    var questions = [
      { key: 'shape', title: "What's your eye shape?", intro: 'Look straight into a mirror with your eyes open and relaxed. Compare with photos, then choose the best match.',
        choices: ['Almond','Round','Upturned','Downturned','Hooded','Monolid','Mature'].map(function(s) { return { value:s.toLowerCase(), title:s, description:config.descriptions[s.toLowerCase()], media:'eye_'+s.toLowerCase() }; }) },
      { key: 'look', title: 'What wing type do you like?', intro: 'Pick the one you are leaning towards',
        choices: [{ value:'classic', title:'Classic cat eye', description:'A uplifted flick with uplift', media:'look_classic' }, { value:'blade', title:'Siren eye', description:'A straight, sharp wing', media:'look_blade' }] },
      {
  key: 'drama',
  title: 'Are you a drama queen?',
  intro: 'How much wing is your thing?',
  choices: [
    {
      value: 'small',
      title: 'No, I like a subtle wing',
      description: 'Skinni',
      media: 'drama_small'
    },
    {
      value: 'med',
      title: 'Kinda, inbetween is fine',
      description: 'Middi',
      media: 'drama_med'
    },
    {
      value: 'large',
      title: 'Yes, I want a dramatic wing',
      description: 'Thicci',
      media: 'drama_large'
    }
  ]
},
      { key: 'color', title: "What's your colour vibe?", intro: '',
        choices: [{ value:'black', title:'Black', description:'Bold and defined' }, { value:'brown', title:'Brown', description:'Soft and natural' }] }
    ];
    try {
      var saved = JSON.parse(sessionStorage.getItem(storageKey));
      if (saved && saved.answers) {
        questions.forEach(function(q) {
          if (q.choices.some(function(c) { return c.value === saved.answers[q.key]; })) answers[q.key] = saved.answers[q.key];
        });
        var incomplete = questionKeys.findIndex(function(k) { return !answers[k]; });
        step = incomplete < 0 ? Math.min(4, Math.max(0, Number(saved.step) || 0)) : incomplete;
      }
    } catch (e) {}
    function save() {
      try { sessionStorage.setItem(storageKey, JSON.stringify({answers:answers,step:step})); } catch (e) {}
    }
    function node(tag, className, text) {
      var el = document.createElement(tag);
      if (className) el.className = className;
      if (text !== undefined && text !== null) el.textContent = text;
      return el;
    }
    function media(key, fallback, optional) {
      var template = root.querySelector('template[data-wq-media="'+key+'"]');
      var content = template && template.content.cloneNode(true);
      var populated = content && content.querySelector('img,video');
      if (!populated && optional) return null;
      var wrap = node('div', 'wq-media');
      if (populated) wrap.appendChild(content);
      else wrap.appendChild(node('span','wq-missing',fallback));
      return wrap;
    }
    function localizedLink(value) {
      var url = new URL(value, location.origin);
      if (url.origin === location.origin) {
        var prefix = (config.root || '/').replace(/\/$/, '');
        if (prefix && url.pathname !== prefix && url.pathname.indexOf(prefix + '/') !== 0) url.pathname = prefix + url.pathname;
      }
      return url.href;
    }
    function link(text, value, cls) {
      var a = node('a', cls || 'wq-primary', text);
      a.href = localizedLink(value);
      return a;
    }
    function renderQuestion(q) {
      var choices = node('fieldset', 'wq-grid wq-grid--'+q.key);
      choices.setAttribute('aria-labelledby','WingQuizTitle');
      q.choices.forEach(function(choice) {
        var option = node('label','wq-option');
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'wing-quiz-'+q.key;
        input.value = choice.value;
        input.checked = answers[q.key] === choice.value;
        var tick = node('span','wq-tick','✓');
        tick.setAttribute('aria-hidden','true');
        option.append(input,tick);
        if (choice.media) {
          var choiceMediaKey = q.key === 'drama' && answers.look === 'blade' ? 'drama_blade_'+choice.value : choice.media;
          var choiceMedia = media(choiceMediaKey,choice.title+' photo',q.key === 'drama');
          if (choiceMedia) option.appendChild(choiceMedia);
        }
        if (choice.flourish) {
          var flourish = node('span','wq-drama',choice.flourish);
          flourish.setAttribute('aria-hidden','true');
          option.appendChild(flourish);
        }
        if (q.key === 'color') {
          var swatch = node('span','wq-swatch wq-swatch--'+choice.value);
          swatch.setAttribute('aria-hidden','true');
          option.appendChild(swatch);
        }
        var copy = node('span','wq-option-copy');
        copy.append(node('span','wq-option-title',choice.title),node('span','wq-option-description',choice.description));
        option.appendChild(copy);
        input.addEventListener('change',function() { answers[q.key]=choice.value; next.disabled=false; save(); });
        choices.appendChild(option);
      });
      body.appendChild(choices);
    }
    function hoodedSlideshow() {
      var card = node('section','wq-hooded-technique');
      var heading = node('h3','','Use our The Blink N Snap technique for hooded eyes');
      var gallery = node('div','wq-hooded-gallery');
      gallery.setAttribute('role','region');
      gallery.setAttribute('aria-label','Blink N Snap technique GIFs');
      gallery.tabIndex = 0;
      ['tech_blink','tech_blink_2','tech_blink_3'].forEach(function(key,index) {
        var slide = media(key,'Blink N Snap demonstration '+(index+1),true);
        if (!slide) return;
        var img = slide.querySelector('img');
        if (img && !img.alt) img.alt = 'Blink N Snap technique, demonstration '+(index+1);
        var figure = node('figure','wq-hooded-slide');
        figure.setAttribute('data-gif-slot',String(index+1));
        figure.appendChild(slide);
        if (index === 2) {
          var position = Number(config.hoodedThirdPosition);
          if (!Number.isFinite(position)) position = 40;
          figure.style.setProperty('--wq-gif-position',Math.max(0,Math.min(100,position))+'%');
        }
        var caption = (config.hoodedCaptions || [])[index];
        if (typeof caption === 'string' && caption.trim()) {
          figure.appendChild(node('figcaption','wq-hooded-caption',caption.trim()));
        }
        gallery.appendChild(figure);
      });
      if (!gallery.children.length) return null;
      card.append(heading,gallery);
      return card;
    }
    function renderResult() {
      var key = questionKeys.map(function(k) {return answers[k];}).join('|');
      var recommendation = config.recommendations[key];
      if (!recommendation) {
        step = 0;
        render();
        return;
      }
      if (answers.shape === 'almond' || answers.shape === 'mature') {
        var note = node('aside', 'wq-note wq-note--' + answers.shape);
        note.appendChild(node('p','',answers.shape === 'almond'
          ? "You're super lucky, almond eyes normally suit any style."
          : "Be patient with yourself. There can be a small learning curve, especially if you've never worn eyeliner before. Give yourself time to practice."));
        body.appendChild(note);
      }
      var guideme = node('section','wq-guideme');
      guideme.append(node('h3','','The GuideMe Kit'),node('p','','A starter kit, with a style we think you’ll love.'));
      var card = node('article','wq-result-card');
      var gallery = node('div','wq-result-gallery');
      gallery.setAttribute('role','region');
      gallery.setAttribute('aria-label','Recommended style photos: best match, then close second');
      gallery.tabIndex = 0;
      var styleNames = [recommendation.first,recommendation.second].map(function(style,index) {
        var name = style.size+' in '+style.color.toLowerCase()+' from the '+style.collection+' Collection';
        var mediaKey = [style.collection,style.size,style.color].join('_').toLowerCase();
        var photo = media(mediaKey,name);
        var img = photo.querySelector('img');
        if (img) img.alt = (index === 0 ? 'Best match: ' : 'A close second: ')+name;
        gallery.appendChild(photo);
        return name;
      });
      var copy = node('div','wq-result-copy');
      copy.append(
        node('span','wq-kicker','Best match'),
        node('h4','',styleNames[0])
      );
      var shopUrl = new URL(localizedLink(config.gmk));
      shopUrl.searchParams.set('wq_source','quiz');
      shopUrl.searchParams.set('wq_color',recommendation.first.color.toLowerCase());
      shopUrl.searchParams.set('wq_collection',recommendation.first.collection.toLowerCase());
      shopUrl.searchParams.set('wq_size',recommendation.first.size.toLowerCase());
      shopUrl.searchParams.set('wq_bundle','single');
      ['wq_second_color','wq_second_collection','wq_second_size'].forEach(function(key) {
        shopUrl.searchParams.delete(key);
      });
      copy.appendChild(link('Add to my GuideMe Kit',shopUrl.href,'wq-primary wq-shop-gmk'));
      copy.appendChild(node('p','wq-close-second','A close second: '+styleNames[1]));
      var duoUrl = new URL(shopUrl.href);
      duoUrl.searchParams.set('wq_bundle','duo');
      duoUrl.searchParams.set('wq_second_color',recommendation.second.color.toLowerCase());
      duoUrl.searchParams.set('wq_second_collection',recommendation.second.collection.toLowerCase());
      duoUrl.searchParams.set('wq_second_size',recommendation.second.size.toLowerCase());
      copy.appendChild(link('Add to my GuideMe Kit Duo',duoUrl.href,'wq-primary wq-shop-gmk wq-shop-duo'));
      card.append(gallery,copy);
      guideme.append(card,node('p','wq-duo-prompt','Love both styles? Choose the Duo: one GuideMe Kit plus a G’fill in your second style.'));
      body.appendChild(guideme);
      if (answers.shape === 'monolid') {
        var monolidTemplate = root.querySelector('[data-wq-monolid]');
        if (monolidTemplate) body.appendChild(monolidTemplate.content.cloneNode(true));
      }
      if (answers.shape === 'hooded' || answers.shape === 'mature') {
        var slideshow = hoodedSlideshow();
        if (slideshow) body.appendChild(slideshow);
      }
      var tryme = node('aside','wq-tryme');
      tryme.appendChild(media('tryme','The TryMe Kit'));
      var trymeCopy = node('div','');
      trymeCopy.append(node('h3','','Want to try every style?'),node('p','','The TryMe Kit lets you explore every style and discover your favourites.'),link('Grab the TryMe Kit',config.tmk));
      tryme.appendChild(trymeCopy);
      body.appendChild(tryme);
      var extras = node('div','wq-secondary-links');
      extras.appendChild(link('Returning customer?',config.refill,'wq-text-link'));
      var team = node('p','','Buying for a dance or cheer team? ');
      team.appendChild(link('Shop our wholesale Performer Kit',config.team,'wq-text-link'));
      extras.appendChild(team);
      body.appendChild(extras);
    }
    function render() {
      body.querySelectorAll('video').forEach(function(v) { v.pause(); });
      body.replaceChildren();
      var result = step === 4;
      title.textContent = result ? 'Meet your perfect wings' : questions[step].title;
      intro.hidden = result;
      intro.textContent = result ? '' : questions[step].intro;
      if (!result && questions[step].key === 'drama') {
        intro.textContent = 'How much wing is your thing?';
      }
      label.textContent = result ? 'Your personalised picks' : 'Question '+(step+1)+' of 4';
      progress.value = result ? 4 : step+1;
      back.hidden = step === 0;
      back.textContent = result ? 'Edit answers' : 'Back';
      next.textContent = result ? 'Retake quiz' : step === 3 ? 'Show my matches →' : 'Next question →';
      next.disabled = !result && !answers[questionKeys[step]];
      if (result) renderResult(); else renderQuestion(questions[step]);
      scroll.scrollTop = 0;
      save();
      if (dialog.open) title.focus({preventScroll:true});
    }
    function release() {
      body.querySelectorAll('video').forEach(function(v) { v.pause(); });
      if (priorOverflow !== null) document.body.style.overflow = priorOverflow;
      priorOverflow = null;
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true});
    }
    document.addEventListener('click',function(event) {
      var trigger = event.target.closest('[data-wing-quiz-open]');
      if (!trigger) return;
      event.preventDefault();
      if (dialog.open) return;
      returnFocus = trigger;
      priorOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      render();
    },{signal:signal});
    root.querySelector('[data-wq-close]').addEventListener('click',function(){dialog.close();},{signal:signal});
    dialog.addEventListener('close',release,{signal:signal});
    dialog.addEventListener('click',function(e) { if (e.target===dialog) {
      var rect=dialog.getBoundingClientRect();
      if(e.clientX<rect.left || e.clientX>rect.right || e.clientY<rect.top || e.clientY>rect.bottom) dialog.close();
    } },{signal:signal});
    next.addEventListener('click',function(){
      if(step===4){answers={shape:'',look:'',drama:'',color:''};step=0;}
      else if(answers[questionKeys[step]])step++;
      render();
    },{signal:signal});
    back.addEventListener('click',function(){step=Math.max(0,step-1);render();},{signal:signal});
    cleanup=function(){if(dialog.open)dialog.close();release();controller.abort();};
    if (new URLSearchParams(window.location.search).get('wing_quiz') === '1' && !dialog.open) {
  returnFocus = document.querySelector('[data-wing-quiz-open]');
  priorOverflow = document.body.style.overflow;
  dialog.showModal();
  document.body.style.overflow = 'hidden';
  render();
}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  document.addEventListener('shopify:section:load',function(e){if(e.target.querySelector('[data-wing-quiz-root]'))mount();});
  document.addEventListener('shopify:section:unload',function(e){if(e.target.querySelector('[data-wing-quiz-root]') && cleanup){cleanup();cleanup=null;}});
})();

  } catch(e) { console.error(e); }
})();
})();
